import { Box, CircularProgress, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import { HtmlTooltip } from "../styled-components/HtmlTooltip";
import { fetchFromApi } from "../helpers/fetchFromApi";
import { aggregateFixtureMarketOdds } from "../helpers/fixtureMarketOdds";


// Mouseover and workspace share the same phase- and time-filtered API result.
const fixtureOddsCache = new Map();
const fixtureOddsPromiseCache = new Map();
export async function fetchFixturePrematchContext(oddsId) {
  const key=window.location.pathname+':'+oddsId;
  const cached=fixtureOddsCache.get(key),now=Date.now();
  if(cached && now<cached.expires)return cached.value;
  if(fixtureOddsPromiseCache.has(key))return fixtureOddsPromiseCache.get(key);
  const promise=(async()=>{
    const response=await fetchFromApi('get-fixture-prematch-context',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({fixture_id:Number(oddsId)})});
    const value=await response.json();
    if(!response.ok||value.success===false||!Array.isArray(value.records))throw Error('PREMATCH_DATA_UNAVAILABLE');
    const kickoff=Date.parse(value.kickoff);
    fixtureOddsCache.set(key,{value,expires:value.historical?now+300000:Math.min(now+60000,Number.isFinite(kickoff)?kickoff:now+60000)});
    return value;
  })();
  fixtureOddsPromiseCache.set(key,promise);
  try{return await promise;}finally{fixtureOddsPromiseCache.delete(key);}
}
export async function fetchFixtureOddsRecords(oddsId){return (await fetchFixturePrematchContext(oddsId)).records;}
export async function fetchFixtureMarketOdds(oddsId,market,options) {
  const context=await fetchFixturePrematchContext(oddsId);
  return {...aggregateFixtureMarketOdds(context.records,market,options),prematch_context:context};
}

export async function fetchMatchWinnerOdds(
  oddsId
) {
  return (
    await fetchFixtureMarketOdds(
      oddsId,
      "1x2"
    )
  )?.outcomes || {};
}


export function OddsTooltip({ oddsId, label, children }) {
  const [highest, setHighest] = useState(false);
  const [average, setAverage] = useState(false);

  async function loadOdds() {
    setHighest(false);
    setAverage(false);

    try {
      const odds =
        await fetchMatchWinnerOdds(
          oddsId
        );

      const selected =
        odds?.[label];

      if (
        !selected ||
        !Number.isFinite(
          selected.highest
        ) ||
        !Number.isFinite(
          selected.average
        )
      ) {
        setHighest("-");
        setAverage("-");
        return;
      }

      setHighest(
        selected.highest.toFixed(
          3
        )
      );

      setAverage(
        selected.average.toFixed(
          3
        )
      );
    } catch (error) {
      console.error(
        "Could not load v3 pre-match odds:",
        oddsId,
        error
      );

      setHighest("-");
      setAverage("-");
    }
  }

  return (
    <div>
      <HtmlTooltip
        onOpen={loadOdds}
        title={
          <Fragment>
            {highest === "-" && <Typography>Pre-Match-Daten nicht verfügbar</Typography>}
            <Box
              display={highest || average ? "none" : "inline-block"}
              style={{
                margin: "auto",
                position: "relative",
                left: "50%",
                transform: "translateX(-50%)",
                height: "10px",
              }}
            >
              <CircularProgress size={20} />
            </Box>

            <Typography display={highest ? "block" : "none"}>
              Pre-Match · highest: {highest}
            </Typography>

            <Typography display={average ? "block" : "none"}>
              Pre-Match · average: {average}
            </Typography>
          </Fragment>
        }
      >
        {children}
      </HtmlTooltip>
    </div>
  );
}
